<template>
  <div class="container-fluid mt-3">

    <h3 class="mb-4 text-primary">
      RELATÓRIO DE BOLETOS
      <!-- Botão Voltar -->
      <button class="btn btn-secondary btn-sm ml-1" @click="$router.go(-1)">
        Voltar
      </button>
    </h3>

    <div class="card shadow-sm">
      <div class="card-body">

          <div class="card mb-3">
  <div class="card-body">
    <div class="row g-2">

      <div class="col-md-2">
        <label>Data início</label>
        <input type="date" v-model="filtros.data_inicio" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Data fim</label>
        <input type="date" v-model="filtros.data_fim" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Pasta</label>
        <input type="text" v-model="filtros.pasta" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Referência</label>
        <input type="text" v-model="filtros.referencia" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Status</label>
        <select v-model="filtros.pago" class="form-control">
          <option value="">Todos</option>
          <option value="1">Pago</option>
          <option value="0">Em aberto</option>
        </select>
      </div>

      <div class="col-md-2 d-flex align-items-end">
        <button class="btn btn-primary w-100" @click="buscar">
          Buscar
        </button>
      </div>

    </div>
  </div>
</div>

        <table class="table table-bordered table-striped text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Pasta</th>
              <th>Referência</th>
              <th>Locador</th>
              <th>Locatário</th>
              <th>Vencimento</th>
              <th>Valor Total</th>
              <th>Pago?</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="boletos.length === 0">
              <td colspan="8">Nenhum boleto encontrado.</td>
            </tr>

            <tr v-for="b in boletos" :key="b.id">
              <td>{{ b.pasta }}</td>
              <td>{{ b.referencia }}</td>
              <td>{{ b.locador }}</td>
              <td>{{ b.locatario }}</td>
              <td>{{ formatarData(b.vencimento) }}</td>
              <td>{{ formatarMoeda(b.valor_total) }}</td>
              <td>
                <span style="color:#FFF"
                  class="badge"
                  :class="b.pago == 1 ? 'bg-success' : 'bg-danger'"
                >
                  {{ b.pago == 1 ? 'Sim' : 'Não' }}
                </span>
              </td>
              <td>
                <router-link
                  :to="`/edicaoBoleto/${b.pasta}/${b.id}`"
                  class="btn btn-sm btn-primary"
                >
                  Visualizar
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

        <nav class="mt-3 text-center">
  <ul class="pagination justify-content-center">
    <li class="page-item" :class="{ disabled: page === 1 }">
      <button class="page-link" @click="page-- && carregar()">«</button>
    </li>

    <li class="page-item disabled">
      <span class="page-link">
        Página {{ page }} de {{ totalPages }}
      </span>
    </li>

    <li class="page-item" :class="{ disabled: page === totalPages }">
      <button class="page-link" @click="page++ && carregar()">»</button>
    </li>
  </ul>
</nav>

      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RelatorioBoletos",
data() {
  return {
    boletos: [],
    filtros: {
      pasta: '',
      referencia: '',
      pago: '',
      data_inicio: '',
      data_fim: ''
    },
    page: 1,
    limit: 10,
    total: 0
  }
},
computed: {
  totalPages() {
    return Math.ceil(this.total / this.limit) || 1;
  }
},
methods: {
  carregar() {
    const params = {
      ...this.filtros,
      page: this.page,
      limit: this.limit
    };

    axios.get(
      'https://www2.royaljardim.com.br/sistema/Boletos/relatorio_filtrado',
      { params }
    ).then(res => {
      this.boletos = res.data.dados;
      this.total = res.data.total;
    });
  },
  buscar() {
    this.page = 1;
    this.carregar();
  },
  formatarData(data) {
    if (!data) return '';
    return new Date(data).toLocaleDateString('pt-BR');
  },
  formatarMoeda(valor) {
    return Number(valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }
},
mounted() {
  this.carregar();
}
};
</script>